import { NavLink } from "react-router";
import React from "react";
import styled, { css } from "styled-components/";

const NavList = styled.ul`
  display: flex;
  align-items: center;
  margin: ${({ theme }) => theme.space[2]};
  padding-left: 0;
`;

const NavItem = styled.li`
  flex: 1;
  overflow: hidden;
  list-style-type: none;
  border-radius: ${({ theme }) => theme.space[1]};
`;

// TODO - This stops isCurrent being passed to Link but doesn't have
// any type checking
const StyledNavLink = styled(NavLink)<{ isCurrent: boolean }>`
  display: block;
  padding: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.purple4};
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.impactMedium};
  font-size: 1.6rem;
  text-decoration: none;
  overflow: hidden;
  border: none;
  text-align: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDarker};
    color: ${({ theme }) => theme.colors.black};
  }

  ${(props) =>
    props.isCurrent &&
    css`
      background-color: ${({ theme }) => theme.colors.red};
      color: ${({ theme }) => theme.colors.white};
      border-radius: ${({ theme }) => theme.radii[1]};
      padding: 1.2rem 0;

      &:hover {
        background-color: ${({ theme }) => theme.colors.redDarker};
      }
    `}
`;

interface ILinks {
  href: string;
  text: string;
}

interface ISubNav {
  links: ILinks[];
}

const SubNav: React.FC<ISubNav> = ({ links }) => (
  <nav>
    <NavList>
      {links.map((l) => (
        <NavItem key={l.href}>
          <StyledNavLink
            to={l.href}
            isCurrent={window.location.pathname === l.href}
          >
            {l.text}
          </StyledNavLink>
        </NavItem>
      ))}
    </NavList>
  </nav>
);

export default SubNav;
